import React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { fieldStyles } from "services/utils";

// Same getFieldSx function
const getFieldSx = (fieldName, saveStatus) => ({
  ...fieldStyles,
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        saveStatus[fieldName] === "success"
          ? "green"
          : saveStatus[fieldName] === "error"
          ? "red"
          : undefined,
    },
    "& fieldset": {
      borderColor:
        saveStatus[fieldName] === "success"
          ? "green"
          : saveStatus[fieldName] === "error"
          ? "red"
          : undefined,
    },
  },
});

const ContactInfo = ({ employeeDetails, setEmployeeDetails, saveStatus, handleFieldSave }) => {
  const { t } = useTranslation();

  return (
    <Box mt={0}>
      <Typography variant="h5" mb={2} mt={2}>
        {t("admin.employees.employeeDialog.employeeDetails.contactInfo")}
      </Typography>

      <Grid container spacing={2}>
        {/* Contact Number 1 */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.contactNumber1")}
            type="tel"
            value={employeeDetails.contactNumber1 || ""}
            onChange={(e) =>
              setEmployeeDetails((prev) => ({ ...prev, contactNumber1: e.target.value }))
            }
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "contactNumber1", {
                contactNumber1: e.target.value,
              })
            }
            sx={getFieldSx("contactNumber1", saveStatus)}
          />
        </Grid>

        {/* Contact Number 2 */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.contactNumber2")}
            type="tel"
            value={employeeDetails.contactNumber2 || ""}
            onChange={(e) =>
              setEmployeeDetails((prev) => ({ ...prev, contactNumber2: e.target.value }))
            }
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "contactNumber2", {
                contactNumber2: e.target.value,
              })
            }
            sx={getFieldSx("contactNumber2", saveStatus)}
          />
        </Grid>

        {/* Emergency Number */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.emergencyNumber")}
            type="tel"
            value={employeeDetails.emergencyNumber || ""}
            onChange={(e) =>
              setEmployeeDetails((prev) => ({ ...prev, emergencyNumber: e.target.value }))
            }
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "emergencyNumber", {
                emergencyNumber: e.target.value,
              })
            }
            sx={getFieldSx("emergencyNumber", saveStatus)}
          />
        </Grid>

        {/* Relative Name */}
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.relativeName")}
            value={employeeDetails.relativeName || ""}
            onChange={(e) =>
              setEmployeeDetails((prev) => ({ ...prev, relativeName: e.target.value }))
            }
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "relativeName", {
                relativeName: e.target.value,
              })
            }
            sx={getFieldSx("relativeName", saveStatus)}
          />
        </Grid>

        {/* Address */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.address")}
            value={employeeDetails.address || ""}
            onChange={(e) => setEmployeeDetails((prev) => ({ ...prev, address: e.target.value }))}
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "address", {
                address: e.target.value,
              })
            }
            sx={getFieldSx("address", saveStatus)}
          />
        </Grid>

        {/* Payroll Transfer Details */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label={t("admin.employees.employeeDialog.employeeDetails.payrollTransferDetails")}
            value={employeeDetails.payrollTransferDetails || ""}
            onChange={(e) =>
              setEmployeeDetails((prev) => ({
                ...prev,
                payrollTransferDetails: e.target.value,
              }))
            }
            onBlur={(e) =>
              handleFieldSave(employeeDetails.id, "payrollTransferDetails", {
                payrollTransferDetails: e.target.value,
              })
            }
            sx={getFieldSx("payrollTransferDetails", saveStatus)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

ContactInfo.propTypes = {
  employeeDetails: PropTypes.object.isRequired,
  setEmployeeDetails: PropTypes.func.isRequired,
  saveStatus: PropTypes.object.isRequired,
  handleFieldSave: PropTypes.func.isRequired,
};

export default ContactInfo;
